import React from 'react';
import styled from 'styled-components';
import { translate } from 'react-i18next';

const Alert = styled.div`
  width: 360px;
  text-align: center;
  margin: auto;
  margin-top: 40px;
  background: ${props => props.theme.negativeTint};
  padding: 1em;
`;

const Wrapper = ({ children, t, ...other }) => (
  <Alert {...other}>{t(children)}</Alert>
);

export default translate()(Wrapper);
